import React, { createContext, type ReactNode, useContext } from 'react';

import { type ErrorUtils } from '../utils/ErrorUtils';
import { errorMessageDuplicateCommonCore } from './constants';

const PfErrorUtilsContext = createContext<ErrorUtils | undefined>(undefined);

interface PfErrorUtilsContextProps {
	errorUtils: ErrorUtils;
	children: ReactNode;
}

export const PfErrorUtilsProvider: React.FC<PfErrorUtilsContextProps> = ({
	errorUtils,
	children,
}) => <PfErrorUtilsContext.Provider value={errorUtils}>{children}</PfErrorUtilsContext.Provider>;

export function usePfErrorUtils(): ErrorUtils {
	const errorUtils = useContext(PfErrorUtilsContext);
	if (errorUtils === undefined) {
		throw new Error(
			`usePfErrorUtils() must be used within a PfErrorUtilsProvider. ${errorMessageDuplicateCommonCore}`,
		);
	}
	return errorUtils;
}
